import React from 'react';
import { observer } from 'mobx-react';

import { ComponentTierName } from '@/constants/enums';
import { useStores } from '@/hooks/use-stores';
import { checkTierPermission } from '@/utils/util-functions';

type Props = {
  children: React.ReactNode;
  componentName: ComponentTierName;
};

const EPTierProtection = observer(({ children, componentName }: Props) => {
  const { stationStore } = useStores();
  const isPermissionTier = checkTierPermission(componentName, stationStore);
  if (!isPermissionTier) {
    return null;
  }
  return isPermissionTier && <> {children} </>;
});

export default EPTierProtection;
